import { useIntl } from 'react-intl';

import { Button } from '@calm-web/design-system';

import deviceImages from '@/../public/_n/images/family-plan/family-devices.png';
import jasperLakeBackground from '@/../public/_n/images/jasper-lake.webp';
import { FamilyPlanLandingProps } from '@/components/familyPlan/FamilyPlanLanding/types';
import Image from '@/components/image/NextImage';
import GridWrapper from '@/components/ui/GridWrapper';
import { useAnalytics } from '@/hooks/analytics';
import { useFormattedCurrency } from '@/hooks/purchase';
import { usePricesState } from '@/hooks/store';
import { CALM_ONE_LINKS } from '@/utils/deeplinks/deeplinks';
import redirect from '@/utils/legacy/redirect';

import messages from './messages';
import {
	BackgroundWrapper,
	ButtonWrapper,
	Content,
	DeviceImageWrapper,
	Heading,
	JasperLake,
	JoinContent,
	JoinHeading,
	Subheading,
	Wrapper,
} from './styles';

const Hero = ({ onClick, adminName, isJoinFlow }: FamilyPlanLandingProps) => {
	const prices = usePricesState();
	const { formatMessage } = useIntl();
	const formatCurrency = useFormattedCurrency();
	const { logEvent } = useAnalytics();

	const onClose = () => {
		logEvent({
			eventName: 'Family Plan Landing : CTA : No Thanks : Clicked',
			eventProps: {
				section: 'hero',
				type: 'button',
			},
		});
		redirect(CALM_ONE_LINKS.app);
	};

	const getHeading = () => {
		if (!isJoinFlow) {
			return formatMessage(messages.heading);
		}

		if (adminName) {
			return formatMessage(messages.headingAccept, {
				name: adminName,
			});
		}

		return formatMessage(messages.headingAcceptNoName);
	};

	const localizedPrice = formatCurrency(prices?.current?.family, prices.pricing_format.currency);

	return (
		<>
			{isJoinFlow ? (
				<BackgroundWrapper>
					<JasperLake>
						<Image
							priority
							alt=""
							loading="eager"
							fill
							style={{ objectFit: 'cover' }}
							src={jasperLakeBackground}
						/>
					</JasperLake>
					<JoinContent>
						<JoinHeading>{getHeading()}</JoinHeading>
						<ButtonWrapper isJoinFlow>
							<Button
								fullWidth
								backgroundColor="white"
								textColor="gray8"
								onPress={() =>
									onClick &&
									onClick({
										section: 'hero',
										copy: messages.ctaAccept.defaultMessage,
									})
								}
							>
								{formatMessage(messages.ctaAccept)}
							</Button>
							<Button
								fullWidth
								backgroundColor="blackAlpha20"
								textColor="white"
								borderColor="gray3"
								onPress={() => onClose()}
							>
								{formatMessage(messages.ctaClose)}
							</Button>
						</ButtonWrapper>
					</JoinContent>
				</BackgroundWrapper>
			) : (
				<Wrapper>
					<GridWrapper columns={4}>
						<Content>
							<Heading>{getHeading()}</Heading>
							<Subheading>
								{formatMessage(messages.subheading, {
									price: localizedPrice,
								})}
							</Subheading>
							<ButtonWrapper>
								<Button
									fullWidth
									backgroundColor="white"
									textColor="gray8"
									onPress={() =>
										onClick &&
										onClick({
											section: 'hero',
											copy: messages.cta.defaultMessage,
										})
									}
								>
									{formatMessage(messages.cta)}
								</Button>
							</ButtonWrapper>
						</Content>
						<DeviceImageWrapper>
							<Image
								style={{
									display: 'block',
									objectFit: 'cover',
									width: '100%',
									height: 'auto',
								}}
								alt="Calm app on phone"
								src={deviceImages}
							/>
						</DeviceImageWrapper>
					</GridWrapper>
				</Wrapper>
			)}
		</>
	);
};

export default Hero;
